import { Box, Container, Typography } from '@mui/material';
import GovButton from '../../UIComponents/Buttons/GovButton';
import {
  activationQuestionCategory,
  getQuestionCategories,
  postQuestionCategory,
  updateQuestionCategory,
} from '../../Services/httpCalls';
import { useState, useEffect } from 'react';
import QuestionCategoriesDataGrid from '../../UIComponents/dataGrids/questionCategoriesDataGrid';
import AddQuestionCategoryModal from '../../UIComponents/Modals/AddQuestionCategoryModal';
import { enqueueSnackbar } from 'notistack';
import EditQuestionCategoryModal from '../../UIComponents/Modals/EditQuestionCategoryModal';

export default function QuestionCategoriesManagement() {
  const [categories, setCategories] = useState([]);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [defaultCategory, setDefaultCategory] = useState(null);
  const [editCategoryId, setEditCategoryId] = useState(null);

  const getQuestionCategoryData = async () => {
    const data = await getQuestionCategories();
    if (data) {
      setCategories(data.categories);
    }
  };

  const submitCategory = async (data) => {
    try {
      await postQuestionCategory(data);
      getQuestionCategoryData();
      enqueueSnackbar('H κατηγορία καταχωρήθηκε', {
        variant: 'success',
        autoHideDuration: 3000,
      });
    } catch (err) {
      enqueueSnackbar('Παρουσιάστηκε σφάλμα', {
        variant: 'error',
        autoHideDuration: 5000,
      });
    } finally {
      handleCloseAddDialog();
    }
  };

  useEffect(() => {
    getQuestionCategoryData();
  }, []);

  const handleOpenAddDialog = () => {
    setOpenAddDialog(true);
  };

  const handleCloseAddDialog = () => {
    setOpenAddDialog(false);
  };

  const handleOpenEditDialog = () => {
    setOpenEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
  };

  const activateCategory = async (category_id) => {
    try {
      await activationQuestionCategory({ is_active: true }, category_id);
      getQuestionCategoryData();
      enqueueSnackbar('H κατηγορία ενεργοποιήθηκε', {
        variant: 'info',
        autoHideDuration: 3000,
      });
    } catch (err) {
      enqueueSnackbar('Παρουσιάστηκε σφάλμα', {
        variant: 'error',
        autoHideDuration: 5000,
      });
    }
  };

  const deactivateCategory = async (category_id) => {
    try {
      await activationQuestionCategory({ is_active: false }, category_id);
      getQuestionCategoryData();
      enqueueSnackbar('H κατηγορία απενεργοποιήθηκε', {
        variant: 'info',
        autoHideDuration: 3000,
      });
    } catch (err) {
      enqueueSnackbar('Παρουσιάστηκε σφάλμα', {
        variant: 'error',
        autoHideDuration: 5000,
      });
    }
  };

  const handleEditCategory = (data) => {
    setDefaultCategory(data.description);
    setEditCategoryId(data.id);
    handleOpenEditDialog();
  };

  const handleSubmitEditCategory = async (data) => {
    try {
      if (editCategoryId) {
        await updateQuestionCategory(data, editCategoryId);
        getQuestionCategoryData();
        enqueueSnackbar('H κατηγορία καταχωρήθηκε', {
          variant: 'success',
          autoHideDuration: 3000,
        });
      }
    } catch (err) {
      enqueueSnackbar('Παρουσιάστηκε σφάλμα', {
        variant: 'error',
        autoHideDuration: 5000,
      });
    } finally {
      handleCloseEditDialog();
    }
  };
  return (
    <>
      <Container maxWidth="xl" sx={{ marginBottom: 2 }}>
        <Typography variant="h1">Διαχείριση κατηγοριών ερωτημάτων</Typography>
        <Typography variant="body1" lineHeight={5}>
          Διαχειριστείτε τις κατηγορίες των ερωτημάτων που θα εμφανίζονται στους
          εξωτερικούς χρήστες
        </Typography>
        <Box sx={{ my: 3 }} display="flex" justifyContent="flex-end">
          <GovButton
            background={'#006736'}
            hoverBackground={'#154a2b'}
            borderColor={'#006736'}
            onClick={handleOpenAddDialog}
            ariaLabel={'admin-add'}
            type={'button'}
            color={'white'}
            variant={'contained'}
          >
            Δημιουργία κατηγορίας
          </GovButton>
        </Box>

        <Box>
          <QuestionCategoriesDataGrid
            rows={categories}
            activateCategory={activateCategory}
            deactivateCategory={deactivateCategory}
            handleEditCategory={handleEditCategory}
          />
        </Box>
      </Container>

      <AddQuestionCategoryModal
        open={openAddDialog}
        handleClose={handleCloseAddDialog}
        submitForm={submitCategory}
      />

      <EditQuestionCategoryModal
        open={openEditDialog}
        handleClose={handleCloseEditDialog}
        submitForm={handleSubmitEditCategory}
        defaultDescription={defaultCategory}
      />
    </>
  );
}
